export const MOCK_LINK = {
    label: 'Link label',
    href: '/',
};
